import { FormGroup, Text } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';
import type { IGroup } from './GroupsAddEdit';
import { ShowYesNo } from '../../../elements/common';
import { KisSettingRead } from './KisSettingRead';

type ExtraGroupSettingsReadProps = {
    group: IGroup;
};

export function ExtraGroupSettingsRead(props: Readonly<ExtraGroupSettingsReadProps>) {
    const translate = getSelectedLanguage();

    return (
        <>
            <FormGroup label={translate.groups.isActive}>
                <Text>
                    <ShowYesNo value={props.group.isActive} />
                </Text>
            </FormGroup>

            <KisSettingRead kisSetting={props.group.kisSetting} />
        </>
    );
}
